module.exports = __webpack_public_path__ + "static/media/OpenSeas_web_5_preview.9b947057.jpg";